<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Profile</div>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.general}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs4 v-if="newIntermediary">
            <v-text-field :label="labels.inter" v-model="interForm.inter" :error-messages="errors.collect('inter')" v-validate="'required|param|max:15'" data-vv-name="inter" :data-vv-as="labels.inter"></v-text-field>
          </v-flex>
          <v-flex xs4 v-else>
            <v-subheader class="queryLabel">{{labels.inter}}</v-subheader>
            <div class="title">{{interForm.inter}}</div>
          </v-flex>
          <v-flex xs8>
            <v-text-field :label="labels.intermediaryName" v-model="interForm.intermediaryName" :error-messages="errors.collect('intermediaryName')" v-validate="'required|entry|max:60'" data-vv-name="intermediaryName" :data-vv-as="labels.intermediaryName"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="newIntermediary">
            <v-autocomplete :label="labels.interGroup" v-model="interForm.interGroupCode" :items="interGroupList" item-text="label" item-value="value" data-vv-name="interGroup" :data-vv-as="labels.interGroup" :error-messages="errors.collect('interGroup')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.interGroup}}</v-subheader>
            <div class="title">{{interForm.interGroupName}}</div>
          </v-flex>
         <v-flex xs6>
            <v-checkbox :label="labels.suspended" v-model="interForm.suspended"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="newIntermediary">
            <cal-picker :label="labels.dateOpened" v-model="interForm.dateOpened" :error-messages="errors.collect('dateOpened')" data-vv-name="dateOpened" :data-vv-as="labels.dateOpened" v-validate="startDateValidation"></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker :label="labels.dateOpened" v-model="interForm.dateOpened" readonly hide-datails ></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker :label="labels.dateClosed" v-model="interForm.dateClosed" :error-messages="errors.collect('dateClosed')" data-vv-name="dateClosed" :data-vv-as="labels.dateClosed" v-validate="endDateValidation" :min="interForm.dateOpened"></cal-picker>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.Contact}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field :label="labels.officeNo" v-model="interForm.officeNo" type="tel" :error-messages="errors.collect('officeNo')" v-validate="'numeric|max:8'" data-vv-name="officeNo" :data-vv-as="labels.officeNo"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.faxNo" v-model="interForm.faxNo" type="tel" :error-messages="errors.collect('faxNo')" v-validate="'numeric|max:8'" data-vv-name="faxNo" :data-vv-as="labels.faxNo"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.add3" v-model="interForm.add3" :error-messages="errors.collect('add3')"  v-validate="'unit_no|max:200'" data-vv-name="add3" :data-vv-as="labels.add3" prefix="#"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.postalCode" v-model="interForm.postalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('postalCode')" v-validate="'numeric|max:6'" data-vv-name="postalCode" :data-vv-as="labels.postalCode" :loading="InterPostalCodeLoading" @change="doInterAddress"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.add1" v-model="interForm.add1" :error-messages="errors.collect('add1')" v-validate="'entry|max:200'" data-vv-name="add1" :data-vv-as="labels.add1"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.add2" v-model="interForm.add2" :error-messages="errors.collect('add2')" v-validate="'entry|max:200'" data-vv-name="add2" :data-vv-as="labels.add2"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.add4" v-model="interForm.add4" :error-messages="errors.collect('add4')" v-validate="'entry|max:200'" data-vv-name="add4" :data-vv-as="labels.add4"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
        <v-flex lg6 md12 xs12>
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
            {{newIntermediary? 'Add Intermediary' : 'Update Intermediary'}}
            <v-icon right>{{newIntermediary? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
           </v-btn>
        </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      labels: {
        inter: 'Intermediary Code*',
        intermediaryName: 'Intermediary Name*',
        interGroup: 'Intermediary Group*',
        dateOpened: 'Date Opended*',
        dateClosed: 'Date Closed',
        officeNo: 'Office No.',
        faxNo: 'Fax No.',
        add1: 'Block/House No.',
        add2: 'Street Name',
        add3: 'Unit No.',
        add4: 'Building Name',
        postalCode: 'Postal Code',
        suspended: 'Is Suspended?',
        Contact: 'Contacts',
        general: 'General'
      },
      interForm: {
        inter: undefined,
        intermediaryName: undefined,
        interGroupCode: undefined,
        interGroupName: undefined,
        dateOpened: undefined,
        dateClosed: undefined,
        officeNo: undefined,
        faxNo: undefined,
        add1: undefined,
        add2: undefined,
        add3: undefined,
        add4: undefined,
        postalCode: undefined,
        suspended: undefined
      },
      interGroupList: [],
      menu: [],
      newIntermediary: false,
      submitting: false,
      InterPostalCodeLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    startDateValidation() {
      return 'required'
    },
    endDateValidation() {
      return 'start_enddate:' + this.interForm.dateOpened
    },
    intermediaryForm() {
      return this.$store.state.adminInter.intermediary
    }
  },
  methods: {
    ...mapActions([
      'interMenuInit'
    ]),
    doInit() {
      // Default value from vuex store 1st
      this.interForm.inter = this.intermediaryForm.inter
      this.interForm.intermediaryName = this.intermediaryForm.intermediaryName
      this.interForm.interGroupCode = this.intermediaryForm.interGroupCode
      this.interForm.interGroupName = this.intermediaryForm.interGroupName
      if (this.intermediaryForm.dateOpened) {
        this.interForm.dateOpened = this.intermediaryForm.dateOpened
      }
      if (this.intermediaryForm.dateClosed) {
        this.interForm.dateClosed = this.intermediaryForm.dateClosed
      }
      this.interForm.officeNo = this.intermediaryForm.officeNo
      this.interForm.faxNo = this.intermediaryForm.faxNo
      this.interForm.add1 = this.intermediaryForm.add1
      this.interForm.add2 = this.intermediaryForm.add2
      this.interForm.add3 = this.intermediaryForm.add3
      this.interForm.add4 = this.intermediaryForm.add4
      this.interForm.postalCode = this.intermediaryForm.postalCode
      if (this.intermediaryForm.suspended) {
        this.interForm.suspended = this.intermediaryForm.suspended
      } else {
        this.interForm.suspended = false
      }
    },
    async getInterGroupList() {
      const apiURI = this.$store.state.adminInter.menu.interGroup
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.interGroupList = data.data.interGroupList
        }
      } catch (err) {
        throw err
      }
    },
    async doInterAddress() {
      const apiUrl = this.$store.state.adminInter.menu.address
      if (apiUrl) {
        try {
          this.InterPostalCodeLoading = true
          const expand = {
            postCode: this.interForm.postalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.interForm.add1 = data.add1
            this.interForm.add2 = data.add2
            this.interForm.add4 = data.add4
          }
          this.InterPostalCodeLoading = false
        } catch (err) {
          this.InterPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doBack() {
      this.$router.push({ name: 'intermediaries' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newIntermediary) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.interForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.$store.dispatch('interMenuInit', this.interForm.inter)
            // Redirect back to listing
            this.$router.push({ name: 'reviewProfile' })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInter.menu.interCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.interForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            this.$store.dispatch('interMenuInit', this.interForm.inter)
            // Redirect back to listing
            this.newIntermediary = false
            this.$router.push({ name: 'intermediaries' })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    Promise.all([this.getInterGroupList()])
    if (this.inter === 'new') {
      this.newIntermediary = true
      this.interForm.dateOpened = new Date()
      this.interForm.suspended = false
    } else {
      this.doInit()
    }
  },
  props: ['inter'],
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
